import { render, staticRenderFns } from "./batch-messages.vue?vue&type=template&id=c2a076a8&scoped=true"
import script from "./batch-messages.vue?vue&type=script&lang=js"
export * from "./batch-messages.vue?vue&type=script&lang=js"
import style0 from "./batch-messages.vue?vue&type=style&index=0&id=c2a076a8&prod&scoped=true&lang=css"
import style1 from "./batch-messages.vue?vue&type=style&index=1&id=c2a076a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a076a8",
  null
  
)

export default component.exports